import { NavigateFunction } from 'react-router';

// Bridge for sagas: useNavigate() is hook-only, so NavigatorSetter stores the fn here at mount.
let _navigate: NavigateFunction | null = null;

export const setNavigate = (fn: NavigateFunction): void => {
  _navigate = fn;
};

export const navigate = (path: string): void => {
  _navigate?.(path);
};
